import React from "react";

import { getContactLink, goTo, useTranslation } from "utils";

import { Link, Typography } from "components";

export const ContactSupport = () => {
  const { t } = useTranslation("tasks");

  return (
    <Typography variant="paragraph-m" className="margin-0">
      {t("help")}
      <Link onClick={(e) => goTo(e, null, getContactLink(), true)} className="margin-left-50">
        {t("contactSupport")}
      </Link>
    </Typography>
  );
};
